<template>
<div>
    <Box @close="cerrar(false)">
        <template #top>Asignar Empleados</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-grid">
                        <InputText label="Empleado" v-model="empleado.emp_nombre">
                            <template>
                                <Button label="Buscar" icon="" @click="buscarEmpleado()"></Button>
                            </template>
                        </InputText>
                    </div>
                </div>
                <b-table :data="empleados" @page-change="pageChange(event)" :total="empleado.page.total" :per-page="empleado.page.size" :current-page="empleado.page.number"
                    pagination-position="bottom" :pagination-rounded="true" :paginated="true" :backend-pagination="true">
                    <template slot-scope="props">
                        <b-table-column label="Empleado" header-class="is-info">{{ props.row.emp_nombre + ' ' + props.row.emp_apellido }}</b-table-column>
                        <!-- <b-table-column label="" header-class="is-info">{{ props.row }}</b-table-column> -->
                        <!-- <b-table-column label="" header-class="is-info"> -->
                        <!-- <b-tag :class="props.row">{{ props.row }}</b-tag> -->
                        <!-- </b-table-column> -->
                        <!-- <b-table-column label="" header-class="is-info"> -->
                        <!-- <div class="nj-flex"> -->
                        <!--  -->
                        <!-- </div> -->
                        <!-- </b-table-column> -->
                    </template>
                </b-table>
            </div>
        </template>
        <template #bottom>
            <!-- <button class="nj-button c-green" @click="asignar()"><i class="mdi mdi-content-save"></i>Asignar</button> -->
        </template>
    </Box>
</div>
</template>

<script>
import { ProyectoService, ResponseStatus } from "../../services"
import { Toast } from "../../util"
import { Box, Button, InputTextarea } from "../components"
import InputText from "../components/InputText.vue"

export default {
    name: "ProyectoAsignarEmpleados",
    components: {
        Box,
        InputTextarea,
        InputText,
        Button,
    },
    props: {
        pry_id: {
            type: Number
        }
    },
    data() {
        return {
            empleado: {
                emp_nombre: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0
                },
            },
            empleados: [],
            empleados_asignados: [],
        }
    },
    methods: {
        paginarEmpleadosAsignados() {
            ProyectoService
                .paginarEmpleadosAsignados({
                    empleado: this.empleado
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.empleados = response.data.list
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        pageChange(number) {
            this.empleado.page.number = number
            this.paginarEmpleadosAsignados()
        },
        // buscarEmpleadosAsignados() {
        //     EmpleadoService
        //         .buscarEmpleadosAsignados({
        //             pry_id: this.pry_id
        //         })
        //         .then(response => {
        //             if (ResponseStatus.isSuccess(response)) {
        //                 this.empleados_asignados = response.data
        //                 this.empleados_asignados.forEach(empleado => {
        //                     empleado.emp_key = `current${empleado.emp_id}`
        //                 })
        //             }
        //             else {
        //                 Toast.error(response.message)
        //             }
        //         })
        //         .catch(error => {
        //             Toast.error(error)
        //         })
        // },
        // buscar() {
        //     this.empleados = []
        //     const request =
        //         EmpleadoService
        //             .buscar({
        //                 empleado: {
        //                     emp_nombre: this.emp_nombre,
        //                     excluir_proyecto: true,
        //                     pry_id: this.pry_id,
        //                 }
        //             }).then(
        //                 response => {
        //                     this.empleados = response.data
        //                 },
        //                 error => {
        //                     Toast.error(error)
        //                     console.error(`error: `, error)
        //                 }
        //             )
        // },
        // agregar(empleado) {
        //     const list = this.empleados_asignados.filter(item => item.emp_id == empleado.emp_id)
        //     if (list.length == 0) {
        //         empleado.emp_key = `added${empleado.emp_id}`
        //         this.empleados_asignados.push(empleado)
        //     } else {
        //         Toast.error(`El empleado ${empleado.emp_nombre} ${empleado.emp_apellido} ya esta asignado`)
        //     }
        // },
        // retirar(empleado) {
        //     this.empleados_retirados.push(empleado)
        //     this.empleados_asignados = this.empleados_asignados.filter(item => item.emp_id != empleado.emp_id)
        // },
        // asignar() {
        //     // preparando los empelados asignados
        //     const empleados_asignados = this.empleados_asignados
        //         .filter(item => item.emp_key == `added${item.emp_id}`)
        //         .map(item => item.emp_id)
        //     // preparando los empelados retirados
        //     const empleados_retirados = this.empleados_retirados.map(item => item.emp_id)
        //     const request = {
        //         pry_id: this.pry_id,
        //         empleados_asignados,
        //         empleados_retirados
        //     }
        //     ProyectoService.asignarEmpleados(request).then(
        //         response => {
        //             Toast.success(response.message)
        //             this.cerrar(true)
        //         },
        //         error => {
        //             Toast.error(error)
        //             console.error(`error: `, error)
        //         }
        //     )
        // },
        cerrar() {
            this.$emit("close")
        }
    },
    mounted() {
        this.paginarEmpleadosAsignados()
    }
}
</script>

<style scoped>
/* .empleadoList {
    border: 1px solid #ccc;
    border-radius: var(--radius);
    padding: 8px;
}

.empleadoItem {
    cursor: pointer;
    line-height: 24px;
    padding: 2px 8px;
}

.empleadoItem:hover {
    background-color: #f2f2f2;
    border-radius: var(--radius);
} */
</style>